import _ from 'lodash';
import NumberHelpers from './../../app/number-helpers';
import SummaryCard from '../../components/reusable-elements/summary-card';
import { useContext } from 'react';
import { IncomeAndExpenseContext } from './income-expense-container';
import { arrayAny } from '../../utils/arrayUtils';

export const IncomeTile = () => {

    const { data, fetchingData, chartSettings, fetchErrors } = useContext(IncomeAndExpenseContext);
    const income = data ?? { received: [] };

    const nh = new NumberHelpers();

    const getCurrentStats = () => {
        if (!income || !arrayAny(income.received)) return { income: 0, pcChange: 0 };

        const current = _.minBy(income.received, r => r.order);
        return { income: current.grandTotal, pcChange: current.percentageChange };
    };

    const headLineFigures = getCurrentStats();

    const averageIncome = () => {
        if (!income || !arrayAny(income.received)) return 0;

        const total = income.received.reduce((acc, r) => acc + r.grandTotal, 0);
        return total / income.received.length;
    };

    const ave = averageIncome();

    const maxIncome = () => {
        if (!income || !arrayAny(income.received)) return 0;

        const max = _.maxBy(income.received, r => r.grandTotal);
        return max.grandTotal;
    };

    const max = maxIncome();

    return (
        <SummaryCard
            loading={fetchingData}
            headerTitle="TOTAL MONTHLY BANK CREDITS"
            summaryValue={nh.convertNumberWithCommas(headLineFigures.income, "£")}
            summaryValueMovement={headLineFigures.pcChange}
            summaryValueMovementSuffix="%"
            options={chartSettings.options}
            series={[{ data: _.orderBy(income.received, r => r.order, 'desc').flatMap(s => s.grandTotal) }]}
            averageValue1={nh.convertNumberWithCommas(ave, "£")}
            averageValue1Label="Avg. Credits Per Month"
            averageValue2={nh.convertNumberWithCommas(max, "£")}
            averageValue2Label="Max. Credits in range"
            error={fetchErrors.transactions}
        />

        
    );
};